import { render, staticRenderFns } from "./invadobay-property-card.vue?vue&type=template&id=0ebcad5a&scoped=true&"
import script from "./invadobay-property-card.vue?vue&type=script&lang=js&"
export * from "./invadobay-property-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebcad5a",
  null
  
)

export default component.exports